import { SEO } from "@/components/SEO";
import { LegalPage } from "../components/site/legal/LegalPage";

const sections = [
  {
    heading: "Acceptance of Terms",
    body: [
      "By visiting or using Blueprint4Joy® (this website), you agree to these Terms & Conditions. If you don't agree with them, please don't use the site.",
    ],
  },
  {
    heading: "Use of This Site",
    body: [
      "This site is here to share Lara Parrish's writing, coaching offers, speaking, and books. You're welcome to read, share, and link to it. Please don't copy, republish, or resell the content without asking us first.",
    ],
  },
  {
    heading: "Intellectual Property",
    body: [
      "All text, photography, design, and the Blueprint4Joy® name and mark belong to Lara Parrish / Blueprint4Joy®, unless otherwise credited. Book titles, excerpts, and cover art are the property of their respective authors and publishers.",
    ],
  },
  {
    heading: "Not Professional Advice",
    body: [
      "The coaching, speaking, and writing shared here are intended to inspire and support — they are not a substitute for medical, psychological, legal, or financial advice. Please consult a qualified professional for guidance specific to your situation.",
    ],
  },
  {
    heading: "Third-Party Links",
    body: [
      "This site links to third-party services we don't control, including Amazon, Interact (the JOYspot™ quiz), and Clubhouse. We aren't responsible for the content, policies, or practices of those services.",
    ],
  },
  {
    heading: "Limitation of Liability",
    body: [
      "This site and its content are provided \"as is.\" We do our best to keep everything accurate and up to date, but we make no guarantees, and we aren't liable for any loss or damage arising from your use of the site.",
    ],
  },
  {
    heading: "Changes to These Terms",
    body: [
      "We may update these terms from time to time. The \"Last updated\" date at the top of this page will always reflect the most recent version.",
    ],
  },
  {
    heading: "Contact",
    body: [
      "Questions about these terms? Reach us at lara@blueprint4joy.com.",
    ],
  },
];

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms & Conditions"
        description="Blueprint4Joy®'s terms and conditions for using this website."
        path="/terms"
      />
      <LegalPage
        eyebrow="Blueprint4Joy®"
        title="Terms & Conditions"
        updated="February 2026"
        sections={sections}
      />
    </>
  );
}
